module.exports = __webpack_public_path__ + "static/media/tipps_icon.66f080e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tipps_icon.svg
// module id = 141
// module chunks = 0